'use client';

import NextLink from '@/components/next-link';
import { useProductList } from '@/components/product-list-context';
import useWishlistStore from '@/store/wishlist.store';
import { event_add_to_wishlist, event_remove_from_wishlist, event_button_click } from '@/utils/gtm';
import { getCookie } from 'cookies-next';
import { useLocale, useTranslations } from 'next-intl';
import { toast } from '@/utils/toast';
import FillHeart from '../icons/fill-heart';
import FavIcon from '../icons/heart-icon';
import PdpHeartIcon from '../icons/pdp-heart-icon';

const AddToWishlist = ({
  fromPdp,
  sku,
  product,
  title,
  className = '',
  iconClassName = '',
  iconSize = '',
  fromProductCard,
  page = 'product-detail-page',
  index,
}) => {
  const t = useTranslations('favorite');
  const productList = useProductList();
  const locale = useLocale();
  const mage = getCookie('mage');

  const { addToWishlist, removeFromWishlist, wishlist } = useWishlistStore(
    (state) => state
  );
  const handleWishList = () => {
    if (wishlist.includes(Array.isArray(sku) ? sku[0] : sku)) {
      removeFromWishlist(Array.isArray(sku) ? sku[0] : sku);
      event_remove_from_wishlist({
        product,
        index,
        locale,
        item_list_id: productList?.list?.item_list_id || page,
        item_list_name: productList?.list?.item_list_name,
      });
      toast.info(t('Removed from wishlist'), {
        position: 'bottom-center',
      });
    } else {
      addToWishlist(Array.isArray(sku) ? sku[0] : sku);
      event_add_to_wishlist({
        product,
        index,
        locale,
        item_list_id: productList?.list?.item_list_id || page,
        item_list_name: productList?.list?.item_list_name,
      });
      toast.success(t('Added to wishlist'), {
        position: 'bottom-center',
      });
    }
  };

  if (title) {
    return (
      <NextLink
        href={`${mage ? '/user/favourite' : '/favourite'}`}
        onClick={() =>
          event_button_click({
            button_name: 'Favourites',
            button_destination: mage ? '/user/favourite' : '/favourite',
            button_location: 'header',
          })
        }
        className={`flex items-center gap-[9px] ${className}`}
      >
        <div className='relative'>
          <span className='flex items-center justify-center'>
            <FavIcon className='size-[14.1px] max-md:size-5 max-sm:size-4' />
          </span>
          {wishlist.length > 0 ? (
            <span className='absolute -top-1.5 left-2.5 flex size-3.5 items-center justify-center rounded-full bg-black text-xs text-white'>
              {wishlist.length}
            </span>
          ) : null}
        </div>
        <span className='text-[13.5px] font-bold max-lg:hidden'>
          {t(title)}
        </span>
      </NextLink>
    );
  }

  if (fromPdp) {
    const inWishList = wishlist?.includes(Array.isArray(sku) ? sku?.[0] : sku);
    return (
      <button
        onClick={handleWishList}
        title='Add to wishlist'
        aria-label={t('add_to_wishlist')}
        className={`flex size-10 items-center justify-center rounded-full bg-white/80 p-1 shadow-md transition-colors hover:bg-gray-50 lg:bg-white/90 ${inWishList ? 'bg-rose-50!' : ''} lg:p-2`}
      >
        <PdpHeartIcon
          fill={inWishList ? '#ef4444' : 'none'}
          className={`size-5 ${inWishList ? 'text-[#ef4444]' : 'text-gray-600'}`}
        />
      </button>
    );
  }

  return (
    <button
      onClick={handleWishList}
      aria-label={t('add_to_wishlist')}
      className={`absolute border border-[#F1F2F3] bg-white ${iconClassName} ${fromProductCard ? 'end-0 top-2 size-9! max-sm:top-0' : 'end-2 top-0'} z-20 flex size-5 items-center justify-center rounded-full sm:size-6.5 md:size-[34px] lg:size-[34px]`}
    >
      {wishlist?.includes(Array.isArray(sku) ? sku?.[0] : sku) ? (
        <FillHeart
          className={` ${fromPdp ? 'size-4' : 'size-5'} ${iconSize}`}
        />
      ) : (
        <FavIcon className={`${fromPdp ? 'size-4' : 'size-5'} ${iconSize}`} />
      )}
    </button>
  );
};

export default AddToWishlist;
